export function openLeaf(parent_id) {
  $(`[data-row-id="${parent_id}"]`).addClass('active-root');
  $(`[data-parent-id="${parent_id}"]`).addClass('active-leaf');
}

export function closeLeaf(parent_id) {
  $(`[data-row-id="${parent_id}"]`).removeClass('active-root');
  $(`[data-parent-id="${parent_id}"]`).each((i, el) => {
    el.classList.remove('active-leaf');
    closeLeaf(el.dataset.rowId);
  });
}

$(document).on('click', '[data-tree-table] .title', e => {
  let parent_el = e.target.closest('tr'); //Using let to avoid babel bug on transpilation
  let parent_id = parent_el.dataset.rowId;

  if (!parent_id) return;

  if (parent_el.classList.contains('active-root')) {
    closeLeaf(parent_id);
  } else {
    openLeaf(parent_id);
  }
});
